import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="text-with-suggestions-input"
export default class extends Controller {
  static targets = ['field']

  connect() {
  }

  fillField(event) {
    event.stopImmediatePropagation()
    if (this.hasFieldTarget) {
      this.fieldTarget.value = event.params.suggestion
    }
  }
}
